export enum WheelColor {
    full = 'full',
    semiFull = 'semiFull',
    semiEmpty = 'semiEmpty',
    empty = 'empty',
    hidden = 'hidden',
}
